// extracted by mini-css-extract-plugin
export default {"ProfileScreen__banner":"ProfileScreen_ProfileScreen__banner__lp6NL"};